import "../assets/css/footer.css";
import Instagram from "../assets/images/Instagram Circle.png";
import Internet from "../assets/images/Internet.png";
import Email from "../assets/images/Email.png";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/Logo.png";

const Footer = () => {
  const navigate = useNavigate();


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Smooth scrolling animation
    });
  };
  const logoutHandler = (action) => {
    localStorage.clear();
    if (action === "user") {
      navigate("/login");
    } else {
      navigate("/provider-login");
    }
  };
  return (
    <>
      <footer className="section bg-footer mt-3">
        <div className="container">
          <div className="row px-3">
            <div className="col-lg-3">
              {/* <div className="logo "> */}
                <h5 className="footer-heading  text-white">YeloSpace</h5>
                {/* <img src={logo} alt="Left Panel Image" /> */}
                <div className="footer-link mt-4">
                  <p>
                  Free Commercial Sublease Platform
                  List your unused space. Get matched fast. No broker fees.

                  Currently focused on NYC & NJ subleases.
                  </p>
                </div>
                {/* <ul className="list-unstyled footer-link mt-4">
                            <li><a href="">Pages</a></li>
                            <li><a href="">Our Team</a></li>
                            <li><a href="">Feuchers</a></li>
                            <li><a href="">Pricing</a></li>
                        </ul> */}
              {/* </div> */}
            </div>

            <div className="col-lg-3">
              <div className="">
                <h5 className="footer-heading  text-white">Mission</h5>
                <div className="footer-link mt-4">
                  <p>
                  YeloSpace helps tenants list and find commercial subleases
                  quickly, transparently, and without broker pressure.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-2">
              <div className="">
                <h5 className="footer-heading  text-white">Company</h5>
                <ul className="list-unstyled footer-link mt-3">
                  <li>
                    <Link to="/about" onClick={scrollToTop}>About Us</Link>
                  </li>
                  <li>
                    <Link to="/community" onClick={scrollToTop}>Community Board</Link>
                  </li>
                  <li>
                    <a onClick={() => logoutHandler("provider")} href="">
                      Be our partner
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="">
                <h5 className="footer-heading  text-white">Connect With Us</h5>
                <div className="mt-3 footer-link">
                  <div className="d-flex">
                    <a href="#">
                      <img src={Email} height={30} />
                      yelospace2@gmail.com
                    </a>
                  </div>
                  <div className="d-flex">
                    <a href="#">
                      <img src={Instagram} height={30} />
                      @yelospace
                    </a>
                  </div>
                  <div className="d-flex">
                    <a href="#">
                      <img src={Internet} height={30} />
                      www.yelospace.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr
            style={{
              height: "1px",
              color: "white",
              "background-color": "white",
              opacity: "1",
            }}
          />
          <div className="text-start mt-5">
            <p className="footer-alt mb-0 f-14">
              © 2026 Design Theme, All Rights Reserved
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
